import './App.css';
import DashboardLayout from './Components/Home';
import Login from './Components/Login';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NotificationPanel from './Components/Notification';
import Setting from './Components/Setting';
import SettingEdit from './Components/SettingEdit';
import ExamManagement from './Components/ExamManagment';
import CreateExam from './Components/ExamCreateForm';
import ExamDetails from './Components/ExamView';
import ExamEdit from './Components/Examedit';
import AddQuestion from './Components/AddQuestion';
import PreviewPaper from './Components/PreviewPaper';
import PublishPaper from './Components/PublishPaper';
import ResultTabel from './Components/ReultTabel';
import ResultReview from './Components/ResultView';
import ExamList from './Components/ByDefault';
import ExamPreview from './Components/DefaultPaper';
import CumissionManagement from './Components/CumissionManagment';
import CumissionView from './Components/CummisionView';
import Invoice from './Components/Invoice';
import CreateCumission from './Components/CumissionForm';
import Dashboard from './Components/Dashboard';
import SoftwareManagement from './Components/SoftwareMangment';
import SoftwareForm from './Components/SoftwareForm';
import BlueprintPage from './Components/BlueprintPage.jsx';
import SoftwareView from './Components/SoftwareView';
import SoftwaregEdit from './Components/SoftwareEdit';
import InstitudeManagement from './Components/InstitudeManagment';
import InstitudeForm from './Components/Institudeform';
import InstitudeEdit from './Components/InstitudeEdit';
import InstituteDetails from './Components/InstitudeView';
import TeacherView from './Components/TeacherView';
import TeacherEdit from './Components/TeacherEdit';
import StudentView from './Components/StudentView';
import StudentEdit from './Components/StudentEdit'
import InstitudeSoftView from './Components/InstitideSoftView';
import InstitudeSoftEdit from './Components/InstitudeSoftEdit';
import StudentResult from './Components/StudentResult';
import QueMangment from './Components/QueManagment';
import AddQuestionForm from './Components/AddQueForm';
import AddParaForm from './Components/ParaForm';
import QuestionView from './Components/QuestionView';
import QuestionEdit from './Components/QuestionEdit';
import QuestionList from './Components/QuestionList';
import QuestionparView from './Components/QuestionparView';
import AutoGenerate from './Components/AutoGenerate.jsx';
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "./Components/ProtectedRoute";


function App() {
  /*useEffect(() => {

    // Disable right click
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // Disable keyboard shortcuts
    const handleKeyDown = (e) => {
      // Ctrl + C
      if (e.ctrlKey && e.key === "c") e.preventDefault();

      // Ctrl + V
      if (e.ctrlKey && e.key === "v") e.preventDefault();

      // Ctrl + U (view source)
      if (e.ctrlKey && e.key === "u") e.preventDefault();

      // Ctrl + S (save)
      if (e.ctrlKey && e.key === "s") e.preventDefault();

      // Ctrl + P (print)
      if (e.ctrlKey && e.key === "p") e.preventDefault();

      // Ctrl + A (select all)
      if (e.ctrlKey && e.key === "a") e.preventDefault();

      // F12
      // if (e.key === "F12") e.preventDefault();

      // Ctrl+Shift+I
      // if (e.ctrlKey && e.shiftKey && e.key === "I") e.preventDefault();

      // Ctrl+Shift+J
      // if (e.ctrlKey && e.shiftKey && e.key === "J") e.preventDefault();

      // Ctrl+Shift+C
      // if (e.ctrlKey && e.shiftKey && e.key === "C") e.preventDefault();
    };

    setInterval(() => {
      const widthThreshold = window.outerWidth - window.innerWidth > 160;
      const heightThreshold = window.outerHeight - window.innerHeight > 160;

      // if (widthThreshold || heightThreshold) {
      //   document.body.innerHTML = "Developer tools detected. Access blocked.";
      // }
    }, 1000);

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("dragstart", (e) => e.preventDefault());
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };

  }, []);*/


  return (
    <BrowserRouter>
      <div className="watermark">AKES EXAM</div>
      <Routes>
        <Route path="/" element={<Login />} />


        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path='/dashboard' element={<Dashboard />} />


          <Route path="softwaremangment" element={<SoftwareManagement />} />
          <Route path="softwareform" element={<SoftwareForm />} />
          <Route path="blueprint" element={<BlueprintPage />} />
          <Route path="softwareview/:id" element={<SoftwareView />} />
          <Route path="softwareEdit/:id" element={<SoftwaregEdit />} />


          <Route path="institudemng" element={<InstitudeManagement />} />
          <Route path="institudeform" element={<InstitudeForm />} />
          <Route path="institudeedit/:id" element={<InstitudeEdit />} />
          <Route path='institudeview/:id' element={<InstituteDetails />} />
          <Route path="teacherview/:id" element={<TeacherView />} />
          <Route path='teacheredit/:id' element={<TeacherEdit />} />
          <Route path='studentview/:id' element={<StudentView />} />
          <Route path='studentresult/:id' element={<StudentResult />} />
          <Route path='studentedit/:id' element={<StudentEdit />} />
          <Route path='institudsoftview/:id' element={<InstitudeSoftView />} />
          <Route path='institudesoftedit/:id' element={<InstitudeSoftEdit />} />


          <Route path='quemanagment' element={<QueMangment />} />
          <Route path='addqueform' element={<AddQuestionForm />} />
          <Route path='addpara' element={<AddParaForm />} />
          <Route path='queview/:id' element={<QuestionView />} />
          <Route path='queedit/:id' element={<QuestionEdit />} />
          <Route path='quelist' element={<QuestionList />} />
          <Route path='question-view/:id' element={<QuestionparView />} />


          <Route path="exammanagment" element={<ExamManagement />} />
          <Route path="examview/:id" element={<ExamDetails />} />
          <Route path="examedit/:id" element={<ExamEdit />} />
          <Route path="createexam" element={<CreateExam />} />
          <Route path="auto-generate/:paperId/:softwareId" element={<AutoGenerate />} />
          <Route path="addquestion/:id" element={<AddQuestion />} />
          <Route path="previewpaper/:id" element={<PreviewPaper />} />
          <Route path="publishpaper" element={<PublishPaper />} />
          <Route path="resulttabel" element={<ResultTabel />} />
          <Route path="resultview" element={<ResultReview />} />
          <Route path="/dashboard/bydefault/:softwareId/:standardId" element={<ExamList />} />
          <Route path="/dashboard/exampreveiw/:paperId" element={<ExamPreview />} />


          <Route path="cumissionmng" element={<CumissionManagement />} />
          <Route path='createcumission' element={<CreateCumission />} />
          <Route path="cumissionview" element={<CumissionView />} />
          <Route path="invoice" element={<Invoice />} />



          <Route path="settings" element={<Setting />} />
          <Route path="settingedit" element={<SettingEdit />} />



          <Route path="notification" element={<NotificationPanel />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
